(() => {
  const fields = new Set(['HD Lens', 'Coating', 'UV', 'Engraving']);
  let queued = false;
  function enhance() {
    queued = false;
    const template = document.getElementById('lr-addon-check-icon');
    if (!template) return;
    const arTemplate = document.getElementById('lr-ar-content');
    const coating = document.querySelector('#avpoptions-container__v2 input[field-name="Coating"]');
    const description = coating?.closest('.ap-options__button-container')?.nextElementSibling;
    if (arTemplate && description?.classList.contains('ap-options__paragraph-container') && !description.querySelector('.lr-ar-comparison')) {
      description.replaceChildren(arTemplate.content.cloneNode(true));
    }
    const uvTemplate = document.getElementById('lr-uv-content');
    const uv = document.querySelector('#avpoptions-container__v2 input[field-name="UV"]');
    const uvDescription = uv?.closest('.ap-options__button-container')?.nextElementSibling;
    if (uvTemplate && uvDescription?.classList.contains('ap-options__paragraph-container') && !uvDescription.querySelector('.lr-uv-content')) {
      uvDescription.replaceChildren(uvTemplate.content.cloneNode(true));
    }
    document.querySelectorAll('#avpoptions-container__v2 .ap-options__button-container input[type="radio"]').forEach(input => {
      if (!fields.has(input.getAttribute('field-name'))) return;
      const row = input.closest('.ap-options__button-container');
      row.classList.add('lr-addon-option');
      const content = [];
      let sibling = row.nextElementSibling;
      while (sibling && !sibling.classList.contains('ap-options__space-container') && !sibling.classList.contains('apo-total-addcharge')) {
        if (fields.has(sibling.querySelector('input[type="radio"]')?.getAttribute('field-name'))) break;
        content.push(sibling);
        sibling = sibling.nextElementSibling;
      }
      content.forEach((part, index) => {
        part.classList.add('lr-addon-content');
        part.classList.toggle('lr-addon-content-last', index === content.length - 1);
        part.dataset.lrSelected = String(input.checked);
      });
      const label = input.closest('label');
      if (!label || label.querySelector('.lr-addon-check')) return;
      const check = document.createElement('i');
      check.className = 'lr-addon-check';
      check.setAttribute('aria-hidden', 'true');
      check.append(template.content.cloneNode(true));
      label.append(check);
    });
  }
  function start() {
    const main = document.getElementById('MainContent');
    if (!main) return;
    new MutationObserver(() => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(enhance);
    }).observe(main, { childList:true, subtree:true });
    main.addEventListener('change', () => requestAnimationFrame(enhance));
    enhance();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true});
  else start();
})();
